import { useEffect, useState } from "react";
import { Zap, Menu, X } from "lucide-react";

const LINKS = [
  { label: "Services", href: "#services", testid: "nav-link-services" },
  { label: "Case Studies", href: "#work", testid: "nav-link-case-studies" },
  { label: "Process", href: "#process", testid: "nav-link-process" },
  { label: "Contact", href: "#contact", testid: "nav-link-contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-40 transition-[background-color,border-color,backdrop-filter] duration-500 ${
        scrolled ? "backdrop-blur-xl bg-black/60 border-b border-white/10" : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-5 sm:px-8 h-[72px] flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="font-heading leading-none select-none">
          <span className="block text-white font-extrabold text-lg tracking-tight">branded</span>
          <span className="block text-[#A3E635] font-extrabold text-lg tracking-tight -mt-1">
            by knowfinity
          </span>
        </a>

        <div className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testid}
              className="font-mono2 text-xs tracking-[0.2em] uppercase text-slate-400 hover:text-[#A3E635] transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            data-testid="nav-cta-button"
            className="group inline-flex items-center gap-2 rounded-full bg-[#A3E635] px-5 py-2.5 font-mono2 text-xs font-bold tracking-[0.15em] uppercase text-black transition-all duration-300 hover:bg-[#84CC16] hover:shadow-[0_0_32px_rgba(163,230,53,0.4)]"
          >
            <Zap size={14} className="transition-transform duration-300 group-hover:rotate-12" />
            Book Growth Audit
          </a>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen(!open)}
          className="md:hidden text-white p-2"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden backdrop-blur-xl bg-black/80 border-t border-white/10 px-6 py-6 flex flex-col gap-5">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`${l.testid}-mobile`}
              onClick={() => setOpen(false)}
              className="font-mono2 text-sm tracking-[0.2em] uppercase text-slate-300 hover:text-[#A3E635] transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            data-testid="nav-cta-button-mobile"
            onClick={() => setOpen(false)}
            className="inline-flex w-fit items-center gap-2 rounded-full bg-[#A3E635] px-5 py-2.5 font-mono2 text-xs font-bold tracking-[0.15em] uppercase text-black"
          >
            <Zap size={14} /> Book Growth Audit
          </a>
        </div>
      )}
    </header>
  );
};
